import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, canonical, image, schema, type = 'website' }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    {keywords && <meta name="keywords" content={keywords} />}
    <link rel="canonical" href={`https://popcrownofficial.com${canonical}`} />

    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={`https://popcrownofficial.com${canonical}`} />
    <meta property="og:image" content={image || 'https://popcrownofficial.com/hero_mural_optimized.jpg'} />
    <meta property="og:type" content={type} />
    <meta property="og:site_name" content="PopCrown Official" />
    <meta property="og:locale" content="en_GB" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image || 'https://popcrownofficial.com/hero_mural_optimized.jpg'} />

    {schema && schema.map((s, i) => (
      <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
    ))}
  </Helmet>
);

export default SEO;
